//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { Button, Dialog } from '../../../../Components/MUIs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { DatePicker } from '../../../../Components/MUIs';
import { getColumnDefs1 } from './SUB_BASIC_01_ColumnDefs';
import { useDispatch, useSelector } from 'react-redux';
import {
  setModalStartYear,
  setModalEndYear,
} from '../../../../Reducer/SearchReducer';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import {
  AppBar,
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import {
  Close as CloseIcon,
  Save as SaveIcon,
  Print as PrintIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import Split from 'react-split';
import dayjs from 'dayjs';
import ConfirmDialog from '../../../../Components/ConfirmDialog';
//#endregion

function SUB_BASIC_01(props) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  // 적격수급인 평가서 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick1) {
      if (!props.validateSelection()) {
        props.setFilterClick1(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo?.searchText || '');
      props.setFilterClick1(false);
    }
    if (props.searchClick1) {
      if (!props.validateSelection()) {
        props.setSearchClick1(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick1(false);
    }
    if (props.saveClick1) {
      if (!props.validateSelection()) {
        props.setSaveClick1(false);
        return;
      }

      props.Save1();
      props.setSaveClick1(false);
    }
    if (props.printClick1) {
      if (!props.validateSelection()) {
        props.setPrintClick1(false);
        return;
      }

      props.PrintLogic2();
      props.setPrintClick1(false);
    }
    if (props.listClick1) {
      if (!props.validateSelection()) {
        props.setListClick1(false);
        return;
      }

      props.setModalToggle3(true);
      props.setListClick1(false);
    }
  }, [
    props.filterClick1,
    props.searchClick1,
    props.saveClick1,
    props.printClick1,
    props.listClick1,
  ]);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        gridRef={props.gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'multiple'}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        saveClick1={() => {
          if (!props.validateSelection()) return;

          props.Save1();
        }}
        onCellClicked={(e) => {
          // 필요 시 특정 행 선택 등 처리
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'coNm');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
      />

      {/* 적격수급인 평가표 이동 버튼, 수정 팝업 창 */}
      {props.modalToggle1 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            fullScreen
            titleSx={{ p: 0 }}
            title={
              <AppBar
                sx={{
                  color: '#fff',
                  backgroundColor: '#2CA900',
                  position: 'static',
                }}
              >
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => {
                      props.setModalToggle1(false);
                      props.setModalRowData1(props.INPUTS);
                    }}
                    aria-label="close"
                    sx={{ marginRight: 2 }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography
                    sx={{
                      ml: 2,
                      flex: 1,
                      textAlign: 'left',
                    }}
                    variant="h6"
                    component="div"
                  >
                    <Box
                      sx={{
                        whiteSpace: 'normal',
                        overflow: 'visible',
                        textOverflow: 'clip',
                        wordWrap: 'break-word',
                      }}
                    >
                      {'평가표'}
                    </Box>
                  </Typography>

                  <Button
                    sx={{
                      mr: 1,
                      color: '#2CA900',
                      borderColor: '#2CA900',
                      backgroundColor: '#fff',
                      '&:hover': {
                        backgroundColor: '#249100', // hover 시 배경색
                        color: '#fff',
                      },
                    }}
                    name={
                      <>
                        <SaveIcon />
                        저장
                      </>
                    }
                    onClick={(e) => {
                      props.SaveLogic2();
                    }}
                    variant="outlined"
                  />
                </Toolbar>
              </AppBar>
            }
            open={props.modalToggle1}
            onClose={(e) => props.setModalToggle1(false)}
            content={
              <Box sx={{ height: '100%', p: 3 }}>
                <Split
                  sizes={[50, 50]} // 초기 비율
                  minSize={150} // 최소 크기
                  expandToMin={false} // 최소 크기보다 작아지지 않도록 설정
                  gutterSize={10} // 드래그 바 크기
                  gutterAlign="center"
                  cursor="col-resize"
                  className="split-container"
                >
                  {/* 왼쪽 영역 */}
                  <Box sx={{ width: '100%', height: '100%' }}>
                    <Stack
                      sx={{ width: '100%', height: '100%', overflow: 'auto' }}
                    >
                      <React.Fragment>
                        {/* 제목 */}
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            px: 2,
                            py: 0.5,
                            borderRadius: '4px',
                            backgroundColor: '#e3f2fd', // 연한 파란색 배경
                            color: '#1976d2',
                            display: 'inline-block',
                          }}
                        >
                          평가 기준
                        </Typography>
                        {/* 테이블 영역 */}
                        <TableContainer
                          component={Paper}
                          sx={{
                            overflow: 'auto',
                            '&::-webkit-scrollbar': {
                              width: '8px',
                              height: '8px', // 가로 스크롤바도 동일한 높이로 설정
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: 'rgba(0, 0, 0, 0.1)', // 스크롤바 색상
                              borderRadius: '4px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1', // 스크롤바 트랙 색상
                            },
                          }}
                        >
                          <Table
                            sx={{
                              size: 'small',
                              border: 1,
                              borderColor: 'divider',
                            }}
                          >
                            <colgroup>
                              <col style={{ width: '10%' }} />
                              <col style={{ width: '25%' }} />
                              <col style={{ width: '40%' }} />
                              <col style={{ width: '13%' }} />
                              <col style={{ width: '13%' }} />
                            </colgroup>

                            {/* 헤더 */}
                            <TableHead>
                              <TableRow
                                sx={{
                                  borderRight: 1,
                                  borderColor: 'divider',
                                  backgroundColor: '#E4E8E9',
                                }}
                              >
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  NO.
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  평가항목
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  평가기준
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  배점
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ fontWeight: 'bold' }}
                                >
                                  점수
                                </TableCell>
                              </TableRow>
                            </TableHead>

                            {/* 바디 */}
                            <TableBody>
                              {props.evaluationItems.map((row) => (
                                <TableRow key={row.no}>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                    }}
                                  >
                                    {row.no}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                    }}
                                  >
                                    <TextField
                                      fullWidth
                                      value={row.item || ''}
                                      onChange={(e) =>
                                        props.onItemFieldChange?.(
                                          row.no,
                                          'item',
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                      whiteSpace: 'pre-line',
                                    }}
                                  >
                                    <TextField
                                      fullWidth
                                      multiline
                                      minRows={2}
                                      value={row.standard || ''}
                                      onChange={(e) =>
                                        props.onItemFieldChange?.(
                                          row.no,
                                          'standard',
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      whiteSpace: 'pre-line',
                                    }}
                                  >
                                    <TextField
                                      type="number"
                                      fullWidth
                                      value={row.pointValue ?? 0}
                                      onChange={(e) =>
                                        props.onItemFieldChange?.(
                                          row.no,
                                          'pointValue',
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                      inputProps={{ min: 0, max: 100 }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                      whiteSpace: 'pre-line',
                                    }}
                                  >
                                    <TextField
                                      id={`score-input-${row.no}`}
                                      type="number"
                                      fullWidth
                                      value={row.score ?? 0}
                                      onChange={(e) =>
                                        props.onScoreChange(
                                          row.no,
                                          e.target.value,
                                          row.pointValue
                                        )
                                      }
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                      size="small"
                                      inputProps={{
                                        min: 0,
                                        max: row.pointValue, // 최대값 제한
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}

                              {/* 감점항목 */}
                              {props.deductionItems.map((row, idx) => (
                                <TableRow key={`deduction-${idx}`}>
                                  <TableCell
                                    align="center"
                                    colSpan={2}
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#F3F7F8',
                                      fontSize: '12px',
                                    }}
                                  >
                                    {'감점사항'}
                                  </TableCell>
                                  <TableCell
                                    // align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#F3F7F8',
                                      whiteSpace: 'pre-line',
                                    }}
                                  >
                                    <TextField
                                      fullWidth
                                      multiline
                                      minRows={2}
                                      value={row.standard || ''}
                                      onChange={(e) =>
                                        props.onDeductionFieldChange?.(
                                          idx,
                                          'standard',
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#F3F7F8',
                                      fontSize: '12px',
                                    }}
                                  >
                                    -
                                  </TableCell>
                                  <TableCell
                                    align={'center'}
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      fontSize: '12px',
                                      backgroundColor: '#F3F7F8',
                                    }}
                                  >
                                    <TextField
                                      id={`deduction-input-${idx}`}
                                      type="number"
                                      fullWidth
                                      value={row.score ?? 0}
                                      onChange={(e) =>
                                        props.onDeductionChange(
                                          idx,
                                          e.target.value,
                                          10
                                        )
                                      }
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                      size="small"
                                      inputProps={{
                                        min: 0,
                                        max: 10,
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}

                              {/* 합계 */}
                              <TableRow
                                sx={{
                                  backgroundColor: '#F5F5F5',
                                  fontWeight: 'bold',
                                }}
                              >
                                <TableCell
                                  align="center"
                                  colSpan={3}
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                    whiteSpace: 'pre-line',
                                  }}
                                >
                                  합계
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                    whiteSpace: 'pre-line',
                                  }}
                                >
                                  {props.evaluationItems.reduce(
                                    (sum, i) => sum + i.pointValue,
                                    0
                                  )}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                    whiteSpace: 'pre-line',
                                  }}
                                >
                                  {props.modalRowData1?.totalScore ?? 0}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </React.Fragment>
                    </Stack>
                  </Box>
                  {/* 오른쪽 영역 */}
                  <Box sx={{ width: '100%', height: '100%' }}>
                    <Stack
                      sx={{
                        width: '100%',
                        height: '100%',
                        overflow: 'auto',
                        ml: 1,
                      }}
                    >
                      {' '}
                      <React.Fragment>
                        {/* 제목 */}
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            px: 2,
                            py: 0.5,
                            borderRadius: '4px',
                            backgroundColor: '#e3f2fd', // 연한 파란색 배경
                            color: '#1976d2',
                            display: 'inline-block',
                          }}
                        >
                          평가자 의견/등급
                        </Typography>

                        {/* 테이블 영역 */}
                        <TableContainer
                          component={Paper}
                          sx={{
                            overflow: 'auto',
                            border: 1,
                            borderColor: 'divider',
                            borderRadius: 1,
                            mb: 3,
                          }}
                        >
                          <Table
                            sx={{
                              border: 1,
                              borderColor: 'divider',
                              tableLayout: 'fixed',
                            }}
                          >
                            <colgroup>
                              <col style={{ width: '80%' }} />
                              <col style={{ width: '20%' }} />
                            </colgroup>
                            <TableBody>
                              {/* 제목 */}
                              <TableRow>
                                <TableCell
                                  align="center"
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                    backgroundColor: '#FFF',
                                  }}
                                >
                                  평가자 의견
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                    backgroundColor: '#FFF',
                                  }}
                                >
                                  평가 등급
                                </TableCell>
                              </TableRow>

                              {/* 입력 영역 */}
                              <TableRow>
                                <TableCell
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    p: '0.5rem',
                                  }}
                                >
                                  <Box sx={{ position: 'relative' }}>
                                    <TextField
                                      fullWidth
                                      multiline
                                      minRows={3}
                                      maxRows={3}
                                      size="medium"
                                      placeholder="의견 입력"
                                      value={
                                        props.modalRowData1?.evaluatorOpinion ||
                                        ''
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value.slice(
                                          0,
                                          100
                                        );
                                        props.setModalRowData1?.((prev) => ({
                                          ...prev,
                                          evaluatorOpinion: value,
                                        }));
                                      }}
                                      inputProps={{ maxLength: 100 }}
                                      sx={{
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                        },
                                      }}
                                    />

                                    {/* 글자 카운트 */}
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        position: 'absolute',
                                        bottom: 6,
                                        right: 10,
                                        color: 'gray',
                                        backgroundColor: 'white',
                                        px: 0.5,
                                        fontSize: '12px',
                                        pointerEvents: 'none',
                                      }}
                                    >
                                      {
                                        (
                                          props.modalRowData1
                                            ?.evaluatorOpinion || ''
                                        ).length
                                      }
                                      /100
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    p: '1rem',
                                    verticalAlign: 'middle',
                                    minWidth: '100px',
                                  }}
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {props.modalRowData1?.grade || '-'}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* 제목 */}
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            px: 2,
                            py: 0.5,
                            borderRadius: '4px',
                            backgroundColor: '#e3f2fd', // 연한 파란색 배경
                            color: '#1976d2',
                            display: 'inline-block',
                          }}
                        >
                          등 급
                        </Typography>

                        {/* 테이블 영역 */}
                        <TableContainer
                          component={Paper}
                          sx={{
                            overflow: 'auto',
                            border: 1, // ← 전체 테두리
                            borderColor: 'divider', // ← MUI Divider 색상
                            borderRadius: 1, // ← 모서리 둥글게 (옵션)
                            '&::-webkit-scrollbar': {
                              width: '8px',
                              height: '8px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: 'rgba(0, 0, 0, 0.1)',
                              borderRadius: '4px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                            },
                          }}
                        >
                          <Table
                            sx={{
                              size: 'small',
                              border: 1,
                              borderColor: 'divider',
                            }}
                          >
                            {/* 헤더 */}
                            <TableHead>
                              <TableRow
                                sx={{
                                  borderRight: 1,
                                  borderColor: 'divider',
                                  backgroundColor: '#E4E8E9',
                                }}
                              >
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  등급
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  득점
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  이행수준
                                </TableCell>
                              </TableRow>
                            </TableHead>

                            {/* 바디 */}
                            <TableBody>
                              {props.gradeItems.map((row) => (
                                <TableRow
                                  key={row.no}
                                  sx={{
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    backgroundColor: '#E4E8E9',
                                  }}
                                >
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                    }}
                                  >
                                    {row.grade}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderRight: 1,
                                      borderColor: 'divider',
                                      backgroundColor: '#FFF',
                                    }}
                                  >
                                    {row.score}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    sx={{
                                      backgroundColor: '#FFF',
                                    }}
                                  >
                                    {row.standard}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </React.Fragment>
                    </Stack>
                  </Box>
                </Split>
              </Box>
            }
            useCloseButton={false}
            onSave={() => {}}
            maxWidth="sm"
          />
        </div>
      )}

      {/* 사업장 관리자 관리 안 ID 설정 팝업 창 */}
      {props.modalToggle2 && (
        <Dialog
          title="수급업체 평가 목록"
          open={props.modalToggle2}
          onClose={(e) => props.setModalToggle2(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          maxWidth="md"
          content={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* 검색 및 버튼 영역 */}
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent={'space-between'}
                sx={{ my: 1 }}
              >
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <DatePicker
                    views={['year']}
                    openTo="year"
                    name="검색시작연도"
                    value={
                      searchInfo?.modalStartYear
                        ? dayjs(searchInfo.modalStartYear, 'YYYY')
                        : dayjs().subtract(1, 'year')
                    }
                    onChange={(date) => {
                      const selectedYear = date
                        ? dayjs(date).format('YYYY')
                        : '';
                      dispatch(setModalStartYear(selectedYear));
                    }}
                    currentLocale="ko"
                    format="YYYY"
                    sx={{ width: 150 }}
                  />
                  <Typography>~</Typography>
                  <DatePicker
                    views={['year']}
                    openTo="year"
                    name="검색종료연도"
                    value={
                      searchInfo?.modalEndYear
                        ? dayjs(searchInfo.modalEndYear, 'YYYY')
                        : dayjs()
                    }
                    onChange={(date) => {
                      const selectedYear = date
                        ? dayjs(date).format('YYYY')
                        : '';
                      dispatch(setModalEndYear(selectedYear));
                    }}
                    currentLocale="ko"
                    format="YYYY"
                    sx={{ width: 150 }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => props.PopupClickEvent3()}
                  >
                    새 평가 등록
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{ color: '#9370DB', borderColor: '#9370DB' }}
                    startIcon={<PrintIcon />}
                    onClick={() => {
                      props.PrintLogic1?.();
                    }}
                  >
                    인쇄
                  </Button>
                </Box>
              </Stack>

              {/* 테이블 영역 */}
              <TableContainer sx={{ maxHeight: 300, mb: 2 }}>
                <Table size="small" stickyHeader sx={{ tableLayout: 'fixed' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        NO
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        연도
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        반기
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        최종수정일
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        평가표조회
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          width: '25%',
                        }}
                      >
                        삭제
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.modalRowData2 && props.modalRowData2.length > 0 ? (
                      props.modalRowData2.map((row, index) => (
                        <TableRow
                          key={row.sbmId}
                          hover
                          selected={
                            props.selectedModalRowData2?.sbmId === row.sbmId
                          }
                          onClick={() => {
                            props.setSelectedModalRowData2?.(row);
                          }}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: '#f5f5f5',
                            },
                            '&.Mui-selected': {
                              backgroundColor: '#e3f2fd',
                              '&:hover': {
                                backgroundColor: '#bbdefb',
                              },
                            },
                          }}
                        >
                          <TableCell align="center" sx={{ width: '25%' }}>
                            {index + 1}
                          </TableCell>
                          <TableCell align="center" sx={{ width: '25%' }}>
                            {row.sbmYear}
                          </TableCell>
                          <TableCell align="center" sx={{ width: '25%' }}>
                            {row.sbmHalf}
                          </TableCell>
                          <TableCell align="center" sx={{ width: '25%' }}>
                            {row.updateDate
                              ? dayjs(row.updateDate).format('YYYY-MM-DD')
                              : ''}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              width: '25%',
                              color: '#4498ecff',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                            }}
                            onClick={() => {
                              props.PopupClickEvent1(row);
                            }}
                          >
                            이동
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              width: '25%',
                              color: '#f44336',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                            }}
                            onClick={() => {
                              props.deleteClick?.(row);
                            }}
                          >
                            <DeleteIcon />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="center"
                          sx={{ py: 3, color: 'text.secondary' }}
                        >
                          등록된 파일이 없습니다.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          }
        />
      )}

      {props.modalToggle3 && (
        <Dialog
          title="등록할 평가표의 연도와 반기를 선택해주세요."
          open={props.modalToggle3}
          onClose={(e) => {
            props.setModalToggle3(false);
            props.setModalRowData1((prev) => ({
              ...prev,
              sbmYear: dayjs().format('YYYY'),
              sbmHalf: '상반기',
            }));
          }}
          onSave={() => {
            const sbmYear = props.modalRowData1?.sbmYear;
            const sbmHalf = props.modalRowData1?.sbmHalf || '상반기';
            const list = props.modalRowData2 || [];
            const isDuplicate = list.some(
              (row) =>
                String(row.sbmYear) === String(sbmYear) &&
                String(row.sbmHalf) === String(sbmHalf)
            );
            if (isDuplicate) {
              dispatch(
                showSnackbar({
                  message:
                    '동일한 평가연도와 상/하반기의 평가가 이미 등록되어 있습니다. 다른 연도 또는 반기를 선택해 주세요.',
                  type: 'warning',
                })
              );
              return;
            }
            props.PopupClickEvent1({
              partnerCd: props.modalRowData1.partnerCd,
              sbmYear: props.modalRowData1.sbmYear,
              sbmHalf: props.modalRowData1.sbmHalf,
            });

            props.setModalToggle3(false);
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName="다음"
          closeButtonName="취소"
          useSaveButton={true}
          useSaveAfterClose={false}
          maxWidth="sm"
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                justifyItems: 'center',
                alignItems: 'center',
              }}
            >
              {/* 검색 및 버튼 영역 */}
              <Box
                sx={{
                  display: 'flex',
                  justifyItems: 'center',
                  my: 1,
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  평가연도
                </Typography>
                <DatePicker
                  views={['year']}
                  openTo="year"
                  name="평가연도"
                  value={
                    props.modalRowData1?.sbmYear
                      ? dayjs(props.modalRowData1.sbmYear, 'YYYY')
                      : dayjs()
                  }
                  onChange={(date) => {
                    const selectedYear = date ? dayjs(date).format('YYYY') : '';
                    props.setModalRowData1?.((prev) => ({
                      ...prev,
                      sbmYear: selectedYear,
                    }));
                  }}
                  currentLocale="ko"
                  format="YYYY"
                  sx={{ width: 150 }}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyItems: 'center',
                  my: 1,
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  상/하반기
                </Typography>
                <RadioGroup
                  row
                  value={props.modalRowData1?.sbmHalf || '상반기'}
                  onChange={(e) => {
                    const val = e.target.value;
                    props.setModalRowData1?.((prev) => ({
                      ...prev,
                      sbmHalf: val,
                    }));
                  }}
                >
                  <FormControlLabel
                    value="상반기"
                    control={<Radio size="small" />}
                    label="상반기"
                  />
                  <FormControlLabel
                    value="하반기"
                    control={<Radio size="small" />}
                    label="하반기"
                  />
                </RadioGroup>
              </Box>
            </Box>
          }
        />
      )}

      {/* 평가표 삭제 확인 다이얼로그 */}
      <ConfirmDialog
        open={props.deleteConfirmOpen || false}
        title="평가표 삭제"
        contentText={
          props.deleteRow
            ? `${props.deleteRow.sbmYear}년 ${props.deleteRow.sbmHalf} 평가표를 삭제하시겠습니까?`
            : '해당 평가표를 삭제하시겠습니까?'
        }
        onSave={props.Save3}
        onClose={() => {
          props.setDeleteConfirmOpen?.(false);
          props.setDeleteRow?.(null);
        }}
        saveButtonName="삭제"
        closeButtonName="취소"
      />
    </React.Fragment>
  );
}

export default SUB_BASIC_01;
